import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ChangeStepService {
    currentStepId = 0;
    changedStep: Subject<number> = new Subject<number>();

    constructor() {
        this.changedStep.subscribe((stepId) => {
            this.currentStepId = stepId;
        });
    }

    changeStep(currentStepId: number) {
        this.changedStep.next(currentStepId);
    }
}
